import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=2fe0be95&scoped=true&"
import script from "./indexManage.vue?vue&type=script&lang=js&"
export * from "./indexManage.vue?vue&type=script&lang=js&"
import style0 from "./indexManage.vue?vue&type=style&index=0&id=2fe0be95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0be95",
  null
  
)

export default component.exports